const PxoLoadingTable = ({
    rows = 5,            // padrão
    cols = 4,            // padrão
    headerColor = "bg-gray-300" // padrão (Tailwind)
}) => {

    return (
        
        <table className="border-collapse min-w-[60px] h-full">
            
            {/* HEADER */}
            <thead>
                <tr>
                    {Array.from({ length: cols }).map((_, i) => (
                        <th
                            key={i}
                            className={`${headerColor} px-3 py-2  animate-pulse`}
                        >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </th>
                    ))}
                </tr>
            </thead>

            {/* BODY */}
            <tbody>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                        {Array.from({ length: cols }).map((_, colIndex) => (
                            <td
                                key={colIndex}
                                className="px-3 animate-pulse bg-gray-200 py-[6px]"
                            >
                                <div className="text-[7px] animate-pulse bg-gray-400 rounded-[6px]">
                                    &nbsp;
                                </div>
                                
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>

        </table>
    )
}

export default PxoLoadingTable